var mdfield = 'motorcycle_data';
var cdfield = 'vehicle_type_data';
var crdfield = 'car_data';
var ctfield = 'city_data';
var tipfield = 'tip_data';

var insuranceVehiclesList = function (element, placeholer_text) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = "انتخاب کنید";
    element.select2({
        escapeMarkup: function (markup) {
            return markup;
        },
        templateResult: function (data) {
            if (!data.element) {
                return data.text;
            }
            var $element = $(data.element);
            $text = $element[0].text.split('-');
            if ($text[0] == placeholer_text) {
                return $text[0]
            }

            var $parent = $('<div></div>');
            var $enVehicleType = $('<span></span>');
            var $faVehicleType = $('<span></span>');
            $enVehicleType.addClass('smaller gray-color ltr pull-right');
            $enVehicleType.text($text[1]);
            $faVehicleType.text($text[0]);
            $parent.append($faVehicleType);
            $parent.append($enVehicleType);

            return $parent;
        },
        templateSelection: function (data) {
            if (!data.element) {
                return data.text;
            }
            var $element = $(data.element);
            $vehicleType = $($element[0]).text().split('-');
            if ($vehicleType[0] == placeholer_text) {
                $vehicleType[1] = '';
            }
            var _html = '<div class="parent">\n' +
                '<span class="select2-result-iata" style="float: right">' + $vehicleType[0] + '</span>\n';
            if ($vehicleType.hasOwnProperty(1))
                _html += '<span class="value gray-color smaller ltr" style="float: left;line-height: 20px;">' + $vehicleType[1] + '</span>\n';
            _html += '</div>';
            return _html;
        },
        dir: "rtl",
        placeholder: placeholder,
        width: null,
        matcher: matchCustom
    });
    initSelects();
};

var insuranceCarList = function (element, placeholer_text) {
    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = "انتخاب کنید";
    element.select2({
        escapeMarkup: function(markup) {
            return markup;
        },
        templateResult: function(data) {
            if (!data.element) {
                return data.text;
            }
            var $element = $(data.element);
            $text = $element[0].text.split('-');
            if ($text[0] == placeholer_text){
                return $text[0]
            }

            var $parent = $('<div></div>');
            var $enCarType = $('<span></span>');
            var $faCarType = $('<span></span>');
            $enCarType.addClass('smaller gray-color ltr pull-right');
            $enCarType.text($text[1]);
            $faCarType.text($text[0]);
            $parent.append($faCarType);
            $parent.append($enCarType);
            return $parent;
        },
        templateSelection: function (data) {
            if (!data.element) {
                return data.text;
            }
            var $element = $(data.element);
            $carType = $($element[0]).text().split('-');
            if ($carType[0] == placeholer_text){
                $carType[1] = '';
            }
            var _html = '<div class="parent">\n' +
                '<span class="select2-result-iata" style="float: right">'+$carType[0]+'</span>\n';
            if($carType.hasOwnProperty(1))
                _html += '<span class="value gray-color smaller ltr" style="float: left;line-height: 20px;">'+$carType[1]+'</span>\n';
            _html += '</div>';
            return _html;
        },
        dir: "rtl",
        placeholder: placeholder,
        width: null,
        matcher: matchCustom
    });
    initSelects();
};

var ali = function(selector) { // ali = active li :)
    return $('div.tab-pane.active[id*=-tab]').find(selector);
};

var ili = function(selector) { // ali = active li :)
    return $('div.tab-pane.ins[id*=-insurance-tab]').find(selector);
};

var generalLister = function(_selector){

    $.fn.select2.defaults.set("theme", "bootstrap");
    var placeholder = "انتخاب کنید";
    _selector = _selector || 'select';
    ili(_selector).each(function() {
        if($(this).parent().find('.select2-container').length)
            return;
        $(this).select2({
            escapeMarkup: function(markup) {
                return markup;
            },
            templateResult: function(data) {
                if (!data.element) {
                    return data.text;
                }
                var $element = $(data.element);
                $text = $element[0].text;
                return $text;
            },
            templateSelection: function (data) {
                if (!data.element) {
                    return data.text;
                }
                var $element = $(data.element);
                $text = $($element[0]).text();
                var _html = '<div class="parent">\n' +
                    '<span class="select2-result-iata" style="float: right">'+$text+'</span>\n';
                _html += '</div>';
                return _html;
            },
            dir: "rtl",
            placeholder: placeholder,
            width: null,
            matcher: matchCustom
        });
    });
};

var insuranceVehicleTypeList = function (element) {
    insuranceVehiclesList(element, "نوع وسیله نقلیه");
};


var insuranceCarModelList = function (element) {
    insuranceCarList(element, "مدل خودرو");
};

var insuranceCarTypeList = function(element) {
    insuranceCarList(element, "نوع خودرو");
};

var setCarTypeOptions = function (product, vehicle_type_id, carDataUrl) {
    var types, htm = '';
    var model_label = 'مدل';
    switch(vehicle_type_id) {
        case '367':
            model_label = 'مدل';
            break;
        case '730':
            model_label = 'تعداد نفرات';
            break;
        case '731':
            model_label = 'میزان ظرفیت خودرو';
            break;
        case '732':
            model_label = 'تعداد سیلندر';
            break;
        default:
        // code block
    }

    $.ajax(
        {
            type: "Get",
            url: carDataUrl,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            success: function (list) {
                list.forEach(Ctype => {
                    // htm += '<option value="' + Ctype.type_id + '" data-value="' + Ctype.type_id + '" data-latin-name="' + '">' +  Ctype.type.persian_name +"-"+ Ctype.type.latin_name  + '</option>';
                    htm += '<option value="' + Ctype.id + '" data-value="' + Ctype.id + '" data-latin-name="' + '">' +  Ctype.persian_name +"-"+ Ctype.latin_name  + '</option>';
                });
                $('#'+product+'_model_label').html(model_label);
                // Prepend explicit placeholder and avoid auto-selecting first option
                htm = generateOption('NAN', 'انتخاب کنید') + htm;
                var $carType = $('#'+product+'_car_type_select');
                $carType.html(htm);
                // Force placeholder selection; user must pick car type explicitly
                $carType.val('NAN').trigger('change');
            }
        }
    );

}

$('#thirdparty_car_type_select').on('select2:select change', function (e) {
    // Reset model to placeholder immediately, then populate based on selected car type
    var $model = $('#thirdparty_car_model_select');
    var noCarTypeSelected = $(this).val() === 'NAN';
    if (noCarTypeSelected) {
        // Show dependency message for model when car type not chosen
        $model.html(generateOption('NAN', 'لطفا ابتدا نوع خودرو را وارد کنید'));
        $model.val('NAN').trigger('change');
    } else {
        $model.html(generateOption('NAN', 'انتخاب کنید'));
        $model.val('NAN').trigger('change');
    }
    var car_type_id = $(this).val();
    var vehicle_type_id = $('#thirdparty_vehicle_type_select').val();
    if (car_type_id && car_type_id !== 'NAN') {
        setCarModelOptions('thirdparty', vehicle_type_id, car_type_id);
    }
});

// Reset dependent selects when vehicle type changes to keep placeholders persistent
$('#thirdparty_vehicle_type_select').on('select2:select change', function () {
    var $carType = $('#thirdparty_car_type_select');
    var $model = $('#thirdparty_car_model_select');
    var $buildYear = $('#thirdparty_build_year_select');
    // When vehicle type not selected, show dependency message in car type
    if ($(this).val() === 'NAN') {
        $carType.html(generateOption('NAN', 'لطفا ابتدا نوع وسیله نقلیه را وارد کنید'));
        $carType.val('NAN').trigger('change');
    } else {
        // Rebuild car type options with placeholder
        try {
            var carData = window[crdfield] || [];
            var _html = generateMultipleOptions(carData, 'id', 'persian_name', 'latin_name');
            _html = generateOption('NAN', 'انتخاب کنید') + _html;
            $carType.html(_html);
            $carType.val('NAN').trigger('change');
        } catch (e) {
            // Fallback: ensure at least placeholder exists
            $carType.html(generateOption('NAN', 'انتخاب کنید'));
            $carType.val('NAN').trigger('change');
        }
    }
    // Clear and reset model select to placeholder
    $model.html(generateOption('NAN', 'لطفا ابتدا نوع خودرو را وارد کنید'));
    $model.val('NAN').trigger('change');
    // Reset build year to placeholder
    $buildYear.val('NAN').trigger('change');
});

// On initial load, ensure dependency messages are visible before selections
$(function() {
    var $vehicle = $('#thirdparty_vehicle_type_select');
    var $carType = $('#thirdparty_car_type_select');
    var $model = $('#thirdparty_car_model_select');
    if ($vehicle.length && ($vehicle.val() === undefined || $vehicle.val() === 'NAN' || $vehicle.val() === null)) {
        $carType.html(generateOption('NAN', 'لطفا ابتدا نوع وسیله نقلیه را وارد کنید'));
        $carType.val('NAN').trigger('change');
        $model.html(generateOption('NAN', 'لطفا ابتدا نوع خودرو را وارد کنید'));
        $model.val('NAN').trigger('change');
    }
});

$('#body_car_type_select').on('select2:select', function (e) {
    var car_type_id = $(this).val();
    var vehicle_type_id = $('#body_vehicle_type_select').val();
    setCarModelOptions('body', vehicle_type_id, car_type_id);
});

var setCarModelOptions = function(product, vehicle_type_id, car_type_id){
    var models, ht = '';
    var carDataUrl = car_type_data_url.replace(':vehicle_id', vehicle_type_id);
    carDataUrl = carDataUrl.replace(':car_id', car_type_id);
    $.ajax(
        {
            type: "Get",
            url: carDataUrl,
            headers: {'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')},
            success: function (list) {
                // Always start with a persistent placeholder and avoid auto-select
                ht += generateOption('NAN', 'انتخاب کنید');
                list.forEach(Ctype=>{
                    ht += '<option value="' + Ctype.id + '" data-value="'+Ctype.id+'">' + Ctype.name + '</option>';
                });
                var $modelSelect = $('#'+product+'_car_model_select');
                $modelSelect.html(ht);
                // Force placeholder selection and refresh Select2 UI
                $modelSelect.val('NAN').trigger('change');
            }
        }
    );
}

var generateOption = function(value, text, data_value, selected) {
    if(typeof data_value === 'undefined')
        data_value = '';
    else
        text += '-';

    if(typeof selected === 'undefined')
        selected = '';
    else
        selected = 'selected';

    var _html = '<option value="' + value + '" data-value="'+data_value+'" '+selected+'>' + text + data_value + '</option>';
    return _html;
};

var initVehicleTypeData = function () {
    if (window.hasOwnProperty(cdfield)) {
        return loadVehicleTypeSelect(window[cdfield]);
    }
    $.get({
        url: vehicle_type_data_url,
        dataType: 'JSON',
        success: function(data) {
            window[cdfield] = data;
            return loadVehicleTypeSelect(data);
        }
    });
};

var initCarData = function () {
    if (window.hasOwnProperty(crdfield))
        return loadCarSelect(window[crdfield]);
    $.get({
        url: car_data_url,
        dataType: 'JSON',
        success: function (data) {
            window[crdfield] = data;
            return loadCarSelect(data);
        }
    });
};

/*var initMotorcycleData = function() {
    if(window.hasOwnProperty(mdfield))
        return loadMotorcycleSelect(window[mdfield]);
    $.get({
        url: motorcycle_data_url,
        dataType: 'JSON',
        success: function(data) {
            window[mdfield] = data[0].models;
            return loadMotorcycleSelect(data[0].models);
        }
    });
};*/

var generateMultipleOptions = function(data_arr, value_field, text_field, data_value_field) {
    var _html = '';
    for(var _i = 0; _i < data_arr.length; _i++) {
        _html += generateOption(data_arr[_i][value_field], data_arr[_i][text_field], data_arr[_i][data_value_field]);
    }
    return _html;
};

var getModelsByCarTypeId = function (ctid) {
    var car_data = window[crdfield];
    var _models = [];
    $(car_data).each(function (index, cd) {
        if (cd.id == parseInt(ctid)) {
            _models = cd.models;
        }
    });
    return _models;
};

var initModelsByCarTypeId = function(ctid) {
    var _selector = '.car_model_select';
    var _models = getModelsByCarTypeId(ctid);
    var _html = generateMultipleOptions(_models, 'id', 'name');
    _html = generateOption('NAN', 'انتخاب کنید') + _html;
    ali(_selector).html(_html);

    insuranceCarModelList(ili(_selector));
};

var initMedicalCostByFund = function(fund) {
    var _selector = '.accident-medical-cost';
    var _val = parseInt(fund) * 0.1; //10%
    ali(_selector).val(autoComma(_val) + ' تومان ');
};

var generateCarTypeChangeEvent = function() {
    var _selector = '.car_type_select';
    ili(_selector).change(function() {
        initModelsByCarTypeId(this.value);
    });
};

var generateFundChangeEvent = function() {
    var _selector = '.accident_fund_select';
    ili(_selector).change(function() {
        initMedicalCostByFund(this.value);
    });
};

/*var loadMotorcycleSelect = function(model_data) {
    var _selector = '#motorcycle_type_select';
    var _html = generateMultipleOptions(model_data, 'id', 'name');
    _html = generateOption('NAN', 'انتخاب') + _html;
    ili(_selector).html(_html);
};*/

var loadVehicleTypeSelect = function (car_data) {
    var vehicleTypeSelector = '.vehicle_type_select';
    var _html = generateMultipleOptions(car_data, 'id', 'persian_name', 'latin_name');
    _html = generateOption('NAN', 'انتخاب کنید') + _html;
    ili(vehicleTypeSelector).html(_html);
    generateCarTypeChangeEvent();
    insuranceVehicleTypeList(ili(vehicleTypeSelector));
};

var loadCarSelect = function(car_data) {
    var carSelector = '.car_type_select';
    var _html = generateMultipleOptions(car_data, 'id', 'persian_name', 'latin_name');
    _html = generateOption('NAN', 'انتخاب کنید') + _html;
    ili(carSelector).html(_html);
    generateCarTypeChangeEvent();

    insuranceCarTypeList(ili(carSelector));
};

var getDaysLimit = function(morm, e) {
    var porf = morm == 'min' ? -1 : 1;
    var _days = porf * 365 * 24;
    if(ili(e).data(morm + 'days') != null && typeof ili(e).data(morm + 'days') !== 'undefined')
        _days = Number(ili(e).data(morm + 'days'));
    if(ili(e).data(morm + 'years') != null && typeof ili(e).data(morm + 'years') !== 'undefined'){
        _days = Number(ili(e).data(morm + 'years')) * 365;
    }
    return _days;
};

var getMinDays = function (e) {
    return getDaysLimit('min', e);
};

var getMaxDays = function (e) {
    return getDaysLimit('max', e);
};

var initBuildYears = function(years) {
    years = years || 45;
    var _diff = (2023-1402);
    var _cur_year = (new Date()).getFullYear() - _diff;
    var _html = '';
    for (var _i = _cur_year; _i >= _cur_year - 45; _i--)
        _html += generateOption(_i + '/' + (_i + _diff), (_i + _diff) + ' - ' + _i);
    ili('.build_year_select').html(generateOption('NAN', 'سال') + _html);
    ili('.body_build_year_select').html(generateOption('NAN', 'انتخاب کنید') + _html);
};

var initStartYears = function() {
    var years = ili('.start_year_select').data('minyears') || 100;
    var selected = ili('.start_year_select').data('value') || 'NAN';
    var _diff = (2023-1402);
    var _cur_year = (new Date()).getFullYear() - _diff;
    var _html = '';
    for (var _i = _cur_year; _i >= _cur_year - years; _i--)
        if(_i == selected)
            _html += generateOption(_i , _i, undefined,selected );
        else
            _html += generateOption(_i , _i );
    _html = generateOption('NAN', 'سال') + _html;
    ili('.start_year_select').html(_html);
};

var initBirthYears = function() {
    var years = ili('.birth_year_select').data('minyears') || 100;
    var maxyears = $('.birth_year_select').data('maxyears') || 0;
    var selected = ili('.birth_year_select').data('value') || 'NAN';
    var _diff = (2023-1402);
    var _cur_year = (new Date()).getFullYear() - _diff - maxyears;
    var _html = '';
    for (var _i = _cur_year; _i >= _cur_year - years; _i--)
        if(_i == selected)
            _html += generateOption(_i , _i, undefined,selected );
        else
            _html += generateOption(_i , _i );
    _html = generateOption('NAN', 'سال') + _html;
    ili('.birth_year_select').html(_html);
};

var initBirthMonth = function() {
    var selected = ili('.birth_month_select').data('value') || 'NAN';
    var _html = '';
    var arr = [
        'فروردین',
        'اردیبهشت',
        'خرداد',
        'تیر',
        'مرداد',
        'شهریور',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند',
    ];
    $(arr).each(function(i, a) {
        if((i + 1) == selected)
            _html += generateOption(i + 1 , a , undefined,selected );
        else
            _html += generateOption(i + 1 , a );
    });
    _html = generateOption('NAN', 'ماه') + _html;
    ili('.birth_month_select').html(_html);
};

var initBirthDays = function() {
    var _html = '';
    var selected = ili('.birth_day_select').data('value') || 'NAN';
    for (var _i = 1; _i <= 31; _i++)
        if(_i == selected)
            _html += generateOption(_i , _i, undefined,selected );
        else
            _html += generateOption(_i , _i );
    _html = generateOption('NAN', 'روز') + _html;
    ili('.birth_day_select').html(_html);
};

var initFireBuildYears = function(years) {
    years = years || 40;
    var _diff = (2023-1402);
    var _cur_year = (new Date()).getFullYear() - _diff;
    var _html = '';
    for (var _i = _cur_year; _i >= _cur_year - 40; _i--)
        _html += generateOption(_i, _i);
    _html = generateOption('NAN', 'سال') + _html;
    ili('.fire_build_year_select').html(_html);
};

var interactive_select_selector = '_select select';
var interactive_select2_selector= '_select';
var interactive_select3_selector= '-select';
var interactive_selector_style  = "background-color: #999 !important";

var disableInteractiveSelects = function(clsnames, e) {
    clsnames = clsnames || ['damaged', 'undamaged', 'haveinsurance', 'medicine_profession', 'paramedicine_profession', 'resident', 'student'];
    $(clsnames).each(function(){
        var select1 = '.' + this + interactive_select_selector;
        var select2 = '.' + this + interactive_select2_selector;
        var select3 = '.' + this + interactive_select3_selector;
        e ? inscope(e, select1).attr("disabled", "") | inscope(e, select2).addClass('init-disable') | inscope(e, select3).addClass('init-disable') :
            ili(select1).attr("disabled", "") | ili(select2).addClass('init-disable') | ili(select3).addClass('init-disable');
    });
};

var initSelects = function () {
    $('.searchable').each(function () {
        if ($(this).parent().hasClass('selector')) {
            if ($(this).find('option').length > 6) {
                $(this).parent().find('.custom-select').remove();
                $(this).parent().removeClass('selector');
                generalLister(this);
            }
        } else
            generalLister(this);
    });
    //disableInteractiveSelects();
};

var enableSelect = function(_selector, e) {
    var select1 = _selector + interactive_select_selector;
    var select2 = _selector + interactive_select2_selector;
    var select3 = _selector + interactive_select3_selector;
    var e1 = e2 = e3 = null;
    if(arguments.length < 2){
        e1 = ali(select1);
        e2 = ali(select2);
        e3 = ali(select3);
    } else {
        e1 = inscope(e, select1);
        e2 = inscope(e, select2);
        e3 = inscope(e, select3);
    }
    e1.removeAttr('disabled');
    e2.removeClass('init-disable');
    e3.removeClass('init-disable');
};

var inscope = function(e, selector) {
    return $(e).parents('div.tab-pane[id*=-tab]').find(selector);
};

var damageTypeChange = function(e, val) {
    var previous_company = ili('select[id*=previous_company_select]').val();
    if(previous_company == 'NAN') {
        return;
    }
    disableDamageSelects(e);
    var _selector = '.' + val;
    enableSelect(_selector, e);
    switch(val) {
        case 'damaged':
            inscope(e, 'select[id*=discount_damage_type_select]').change();
            break;
        case 'undamaged':
            inscope(e, 'select[id*=undamaged_select]').change();
            break;
        default:
            disableDateInputs();
            break;

    }
};

$('.damage_type_select').change(function() {
    damageTypeChange(this, $(this).val());
});
var disableSelects =  function(arr, e) {
    $(arr).each(function(i, a) {
        var select1 = '.' + a + interactive_select_selector;
        var select2 = '.' + a + interactive_select2_selector;
        var select3 = '.' + a + interactive_select3_selector;
        if(!e) {
            ali(select1).attr('disabled', '');
            ali(select2).addClass('init-disable');
            ali(select3).addClass('init-disable');
        } else {
            inscope(e, select1).attr('disabled', '');
            inscope(e, select2).addClass('init-disable');
            inscope(e, select3).addClass('init-disable');
        }
    });
};

var disableDamageSelects = function (e) {
    disableSelects(['damaged', 'undamaged'], e);
};

var initThirdParty = function () {
    disableDamageSelects();
};

var bodyInsuranceStatusChange = function(e, val) {
    disableDiscountSelect(e);
    var _selector = '.' + val;
    enableSelect(_selector, e);
};

var bodyInsuranceUnFabricChange = function(e, val) {
    if(val == 'no'){
        disableUnFabricInput();
    }else{
        enableUnFabricInput();
    }
};

var disableDiscountSelect = function() {
    disableSelects(['haveinsurance','zero']);
};

var disableUnFabricInput = function() {
    disableInputsBySelector(['input[name=unfabric_price]']);
};
var enableUnFabricInput = function() {
    enableInputsBySelector(['input[name=unfabric_price]']);
};

var getLiteral = function (num) {
    var literals = {
        1 : 'یک',
        2 : 'دو',
        3 : 'سه',
        4 : 'چهار',
        5 : 'پنج',
        6 : 'شش',
        7 : 'هفت',
        8 : 'هشت',
        9 : 'نه',
        10 : 'ده',
        11 : 'یازده',
        12 : 'دوازده',
        13 : 'سیزده',
        14 : 'چهارده',
        15 : 'پانزده',
        16 : 'شانزده',
        17 : 'هفده',
        18 : 'هجده',
        19 : 'نوزده',
        20 : 'بیست',
        30 : 'سی',
        40 : 'چهل',
        50 : 'پنجاه',
        60 : 'شصت',
        70 : 'هفتاد',
        80 : 'هشتاد',
        90 : 'نود',
        100 : 'صد'
    };
    return literals.hasOwnProperty(num) ? literals[num] : '';
};

var fillSelectByYears = function(_selector, min, max, args) {
    data = [];
    var _i = 0;
    for(_i = min; _i <= max; _i++)
        data.push({value: _i * 12, text: getLiteral(_i) + ' سال'});
    if(max - _i != 0)
        data[data.length - 1].text += ' و بیشتر';
    var _html = '';
    $(args).each(function(i, arg) {
        _html += arg;
    });
    _html += generateMultipleOptions(data, 'value', 'text');
    ili(_selector).html(_html);
};

var initInteractiveInputs = function() {
    ili('.form-group.init-disable').find('input:not([type="checkbox"])').attr('disabled', '');
    ili('.form-group.init-disable').find('select').attr('disabled', '');
};

var disableDateInputs = function() {
    ali('.pdatepicker').parents('.form-group').addClass('init-disable');
    ali('.pdatepicker').attr('disabled', '');
};

var enableInput = function(selector, e) {
    var s1 = e ? inscope(e, selector).parents('.form-group') : ali(selector).parents('.form-group');
    var s2 = e ? inscope(e, selector) : ali(selector);
    s1.removeClass('init-disable');
    s2.removeAttr('disabled');
};

var enableExpireDateInput = function() {
    enableInput('input[name*=expire_date]');
};

var enablePurchaseDateInput = function() {
    enableInput('input[name*=purchase_date]');
};

ili('select[id*=undamaged_select]').change(function(){
    //disableDateInputs();
    if($(this).val() == $(this).find('option:first').val())
        return;
    if($(this).attr("disabled") || $(this).val() > 0)
        return enableExpireDateInput();
    enablePurchaseDateInput();
});
ili('select[id*=discount_damage_type_select]').change(function(){
    disableDateInputs();
    if($(this).val() == $(this).find('option:first').val())
        return;
    enableExpireDateInput();
});

var disableInputsBySelector = function(selectors) {
    $(selectors).each(function(i, s) {
        ali(s).attr('disabled', '');
        ali(s).parents('.form-group').addClass('init-disable');
    });
};

var enableInputsBySelector = function(selectors) {
    $(selectors).each(function(i, s) {
        ali(s).removeAttr('disabled');
        ali(s).parents('.init-disable').removeClass('init-disable');
    });
};

var enableComplexInputs = function() {
    enableInputsBySelector(['input[name=unit_count]', 'input[name=complex_area_size]', 'input[name=complex_furniture_price]']);
};


var disableComplexInputs = function() {
    disableInputsBySelector(['input[name=unit_count]', 'input[name=complex_area_size]', 'input[name=complex_furniture_price]']);
};

var enableNonComplexInputs = function() {
    enableInputsBySelector(['input[name=insurance_area_size]', 'input[name=furniture_price]']);
};

var disableNonComplexInputs = function() {
    disableInputsBySelector(['input[name=insurance_area_size]', 'input[name=furniture_price]']);
};

var enableUse2800 = function() {
    enableInputsBySelector('input[name=fire_use_2800]');
};

var disableUse2800 = function() {
    disableInputsBySelector('input[name=fire_use_2800]');
};

var disablePlolicyInputs = function() {
    disableInputsBySelector([
        'select[name=start_date_day]',
        'select[name=start_date_month]',
        'select[name=start_date_year]',
        'select[name=expire_date_day]',
        'select[name=expire_date_month]',
        'select[name=expire_date_year]',
        'input[name=insurance_owner]',
        'input[name=car_damage_type]',
        'select[name=thirdparty_undamaged]',
        'select[name=thirdparty_driver_undamaged]',
        'select[name=thirdparty_damaged]',
        'select[name=discount_damage_financial_type]',
        'select[name=discount_damage_life_type]',
        'select[name=thirdparty_driver_damaged]',
        'select[name=discount_driver_damage_type]',
    ]);
};

var enablePolicyInputs = function() {
    enableInputsBySelector([
        'select[name=start_date_day]',
        'select[name=start_date_month]',
        'select[name=start_date_year]',
        'select[name=expire_date_day]',
        'select[name=expire_date_month]',
        'select[name=expire_date_year]',
        'input[name=insurance_owner]',
        'input[name=car_damage_type]',
        'select[name=thirdparty_undamaged]',
        'select[name=thirdparty_driver_undamaged]',
    ]);
    $('input[name=insurance_owner]').bootstrapSwitch('state', false);
    $('input[name=car_damage_type]').bootstrapSwitch('state', false);
};

var disableManualInputs = function() {

    disableInputsBySelector([
        'select[name=build_year]',
        'select[name=previous_company]',
        'select[name=start_date_day]',
        'select[name=start_date_month]',
        'select[name=start_date_year]',
        'select[name=expire_date_day]',
        'select[name=expire_date_month]',
        'select[name=expire_date_year]',
        'input[name=insurance_owner]',
        'input[name=car_damage_type]',
        'select[name=thirdparty_undamaged]',
        'select[name=thirdparty_driver_undamaged]',
        'select[name=thirdparty_damaged]',
        'select[name=discount_damage_financial_type]',
        'select[name=discount_damage_life_type]',
        'select[name=thirdparty_driver_damaged]',
        'select[name=discount_driver_damage_type]',
        // 'select[name=vehicle_type_id]',
        // 'select[name=cartype_id]',
        // 'select[name=carmodel_id]',
    ]);
    enableInputsBySelector([
        'input[name=thirdparty_part4_input]',
        'input[name=thirdparty_part3_input]',
        'input[name=thirdparty_part2_input]',
        'input[name=thirdparty_part1_input]',
        'input[name=nationalCode]',
    ]);
};

var enableManualInputs = function() {
    enableInputsBySelector([
        'select[name=build_year]',
        'select[name=previous_company]',
        'select[name=start_date_day]',
        'select[name=start_date_month]',
        'select[name=start_date_year]',
        'select[name=expire_date_day]',
        'select[name=expire_date_month]',
        'select[name=expire_date_year]',
        'input[name=insurance_owner]',
        'input[name=car_damage_type]',
        'select[name=thirdparty_undamaged]',
        'select[name=thirdparty_driver_undamaged]',
        // 'select[name=vehicle_type_id]',
        // 'select[name=cartype_id]',
        // 'select[name=carmodel_id]',
    ]);
    $('input[name=insurance_owner]').bootstrapSwitch('state', false);
    $('input[name=car_damage_type]').bootstrapSwitch('state', false);
    disableInputsBySelector([
        'input[name=thirdparty_part4_input]',
        'input[name=thirdparty_part3_input]',
        'input[name=thirdparty_part2_input]',
        'input[name=thirdparty_part1_input]',
        'input[name=nationalCode]',
    ]);
};

var enableCapacity = function() {
    enableInputsBySelector(['#capacity_select']);
};


var disableCapacity = function() {
    disableInputsBySelector(['#capacity_select']);
    $('#capacity_select').val("-1").trigger('change');
};

var enableCapacityInputs = function() {
    enableInputsBySelector(['#capacity_input']);
};

var disableCapacityInputs = function() {
    disableInputsBySelector(['#capacity_input']);
    $('#capacity_input').val('');
};

var enableLossInputs = function() {
    enableInputsBySelector(['#financial_loss_number_select','#elevator_financial_loss_select']);
};

var disableMedicalCostInputs = function() {
    disableInputsBySelector(['#elevator_medical_cost_select']);
    $('#elevator_medical_cost_select').val("-1").trigger('change');
};

var disableLossInputs = function() {
    disableInputsBySelector(['#financial_loss_number_select','#elevator_financial_loss_select']);
    $('#financial_loss_number_select').val("-1").trigger('change');
    $('#elevator_financial_loss_select').val("-1").trigger('change');
};

var enableMedicalCostInputs = function() {
    enableInputsBySelector(['#elevator_medical_cost_select']);
};

var physicianBranchCategoryChange = function(e, val) {
    disableInteractiveSelects(['medicine_profession', 'paramedicine_profession', 'year'], e);
    var selector = '.' + val.toLowerCase() + '_profession';
    enableSelect(selector, e);
};

var bodyZeroChange = function(e, val) {
    if(val == 'zero'){
        enableInputsBySelector([
            'select[name=Numbering_day]',
            'select[name=Numbering_month]',
            'select[name=Numbering_year]',
        ]);
        disableInputsBySelector([
            '.body-ins-status',
            'select[name=previous_company]',
            'select[name=body_discount]',
        ]);
    }else{
        enableInputsBySelector([
            '.body-ins-status',
        ]);
        $('.body-ins-status').bootstrapSwitch('state', false);
        disableInputsBySelector([
            'select[name=Numbering_day]',
            'select[name=Numbering_month]',
            'select[name=Numbering_year]',
        ]);
    }
};

ili('#physician_branch_category_select').change(function(){
    physicianBranchCategoryChange(this, $(this).val());
});

var physicianResidentChange = function(e, val) {
    if(val){
        var selector = '.resident';
        enableSelect(selector, e);
        disableInteractiveSelects(['fellowship'], e);
    }else{
        disableInteractiveSelects(['resident'], e);
        enableSelect('.fellowship', e);
    }
};

ili('#is_resident_check').change(function(){
    physicianResidentChange(this, $(this).val());
});
var physicianStudentChange = function(e, val) {
    if(val){
        var selector = '.student';
        enableSelect(selector, e);
    }else{
        disableInteractiveSelects(['student'], e);
    }
};

var inquiryMethodChange = function(e, val) {
    if(val){
        enableManualInputs();
    }else{
        disableManualInputs();
    }
};

var insuranceOwnerChange = function(e, val) {
    var selector = '.owner-self';
    if(val){
        disableInputsBySelector([
            'select[name=discount_status]'
        ]);
        $(selector).removeAttr('disabled');
        $('.change-owner').hide();
    }else{
        enableInputsBySelector([
            'select[name=discount_status]'
        ]);
        $(selector).attr("disabled", "");
    }
};

ili('select[id*=discount_status_select]').change(function(){
    switch($(this).val())
    {
        case '1':
            $('.change-owner').hide();
            break;
        default:
            $('.change-owner').show();
            
    }
});

ili('#is_student_check').change(function(){
    physicianStudentChange(this, $(this).val());
});

ili('select[id*=property_type_select]').change(function(){
    switch($(this).find('option[value='+$(this).val()+']').text())
    {
        case 'آپارتمان یا مجتمع':
            enableComplexInputs();
            disableNonComplexInputs();
            break;
        case 'نوع ملک':
            disableComplexInputs();
            disableNonComplexInputs();
            break;
        default:
            disableComplexInputs();
            enableNonComplexInputs();
    }
});

ili('select[id*=structure_materials_select]').change(function(){
    switch($(this).find('option[value='+$(this).val()+']').text())
    {
        case 'بتنی':
            enableUse2800();
            break;
        case 'نوع سازه':
            disableUse2800();
            break;
        default:
            disableUse2800();
    }
});

ili('select[id*=previous_company_select]').change(function(){
    switch($(this).val())
    {
        case 'without':
            disablePlolicyInputs();
            break;
        default:
            enablePolicyInputs();
    }
});
ili('select[id*=_discount_status_select]').change(function(){
    var selector = '.owner-self';
    switch($(this).val())
    {
        case '1':
            $(selector).attr("disabled", "");
            break;
        default:
            $(selector).removeAttr('disabled');
    }
});

ili('select[id*=elevator_type_select]').change(function(){
    switch($(this).find('option[value='+$(this).val()+']').text())
    {
        case 'باربر':
            enableCapacityInputs();
            disableCapacity();
            enableLossInputs();
            disableMedicalCostInputs();
            break;
        case 'نفربر':
            enableCapacity();
            disableCapacityInputs();
            disableLossInputs();
            enableMedicalCostInputs();
            break;
        default:
            enableLossInputs();
            enableCapacity();
            disableCapacityInputs();
            enableMedicalCostInputs();
    }
});

var initBodyInsurance = function () {
    // fillDiscountSelect();
};

/*var initMotorcycleInsurance = function() {
    initMotorcycleData();
};*/

initLifeContractDurationSelect = function () {
    var data = [];
    for(var _i = 5; _i <= 30; _i++)
        data.push({year: _i, title: _i+' سال'});
    ili('#life_contract_duration_select').html(
        generateOption('-1', 'مدت قرارداد') +
        generateMultipleOptions(data, 'year', 'title')
    );
};

initLifePayDurationMethodSelect = function () {
    var data = [];
    data.push({method: 'full', title: 'یکجا'});
    data.push({method: 1, title: 'یک ماهه'});
    data.push({method: 3, title: 'سه ماهه'});
    data.push({method: 6, title: 'شش ماهه'});
    data.push({method: 12, title: 'سالانه'});
    ili('#life_pay_duration_method_select').html(
        generateOption('-1', 'روش پرداخت') +
        generateMultipleOptions(data, 'method', 'title')
    );
};

var autoComma = function(number_input) {
    number_input += '';
    number_input = number_input.split(',').join('');
    x = number_input.split('.');
    x1 = x[0].replace(/\D/g,'');
    x2 = x.length > 1 ? '.' + x[1].replace(/\D/g,'') : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1))
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    return x1 + x2;
};

var initNumberInputs = function(){
    ili('input[type="tel"]').keyup(function(){
        $(this).val(autoComma($(this).val()));
    });
};

var initLifeInsurance = function () {
    initLifeContractDurationSelect();
    initLifePayDurationMethodSelect();
};

var checkChanged = function (checkinput, val) {
    checkinput.hasClass('insurance_owner') && insuranceOwnerChange(checkinput, val);
    checkinput.hasClass('damage-type') && damageTypeChange(checkinput, val);
    checkinput.hasClass('body-ins-status') && bodyInsuranceStatusChange(checkinput, val);
    checkinput.hasClass('body-have-unfabric') && bodyInsuranceUnFabricChange(checkinput, val);
    checkinput.hasClass('body-ins-zero') && bodyZeroChange(checkinput, val);
    checkinput.hasClass('physician-branch') && physicianBranchCategoryChange(checkinput, val);
    checkinput.hasClass('physician-resident') && physicianResidentChange(checkinput, val);
    checkinput.hasClass('physician-student') && physicianStudentChange(checkinput, val);
    checkinput.hasClass('inquiry_method') && inquiryMethodChange(checkinput, val);
};

var init2OptionCheckBoxes = function () {
    ili('span.bootstrap-switch-label').each(function() {
        $(this).html($(this).parents('.form-group').find('label[for*="select"]').html());
    });
    ili('.bootstrap-switch').on('switchChange.bootstrapSwitch', function(e){
        var checkinput = $(this).find('input[type="checkbox"]');
        $(this).hasClass('bootstrap-switch-on') && checkinput.attr('checked', 'checked') | checkChanged(checkinput, checkinput.data('onValue'));
        $(this).hasClass('bootstrap-switch-off') && checkinput.removeAttr('checked') | checkChanged(checkinput, checkinput.data('offValue'));
    });
    ili('.bootstrap-switch').trigger('switchChange.bootstrapSwitch');
};

var initCityData = function() {
    if(window.hasOwnProperty(ctfield))
        return loadCitySelect(window[ctfield]);
    $.get({
        url: city_data_url,
        dataType: 'JSON',
        success: function(data) {
            window[ctfield] = data;
            return loadCitySelect(data);
        }
    });
};

var initTipData = function() {
    if(window.hasOwnProperty(tipfield))
        return loadTipSelect(window[tipfield]);
    $.get({
        url: tip_data_url,
        dataType: 'JSON',
        success: function(data) {
            window[tipfield] = data;
            return loadTipSelect(data);
        }
    });
};

var loadCitySelect = function(city_data) {
    var provinceSelector = '.province_select';
    var _html = generateMultipleOptions(city_data, 'id', 'province_name', '');
    _html = generateOption('NAN', 'استان') + _html;
    ili(provinceSelector).html(_html);
    generateProvinceChangeEvent();
    insuranceCarTypeList(ili(provinceSelector));
};

var loadTipSelect = function(tip_data) {
    var vehicleSelector = '.vehicle_select';
    var _html = generateMultipleOptions(tip_data, 'id', 'title', '');
    $('select[name="vehicle"]').append(_html);
    generateVehicleChangeEvent();

    // --insuranceCarTypeList($(provinceSelector));
};

var generateProvinceChangeEvent = function() {
    var _selector = '.province_select';
    $(_selector).change(function() {
        initCityByProvinceId(this.value);
    });
};
var generateVehicleChangeEvent = function() {
    var _selector = '.vehicle_select';
    $(_selector).change(function() {
        initTipByVehicleId(this.value);
        initUsageByVehicleId(this.value);
        initOtaghBarByVehicleId(this.value);
        initPelakByVehicleId(this.value);
    });
};

var initCityByProvinceId = function(ctid) {
    var _selector = '.city_select';
    var _city = getCityByProvinceId(ctid);
    var _html = generateMultipleOptions(_city, 'id', 'city_name_trans');
    _html = generateOption('NAN', 'انتخاب کنید') + _html;
    $(_selector).html(_html);

    insuranceCarModelList($(_selector));
};

var initTipByVehicleId = function(vhid) {
    var _selector = '.tip_select';
    var _tip = getTipByVehicleId(vhid);
    var _html = generateMultipleOptions(_tip, 'tip_id', 'brand', 'tip');
    $(_selector).empty();
    _html = generateOption('NAN', 'انتخاب کنید') + _html;
    $(_selector).append(_html);
};

var initUsageByVehicleId = function(vhid) {
    var _selector = '.usage_select';
    var _usage = getUsageByVehicleId(vhid);
    var _html = generateMultipleOptions(_usage, 'object_id', 'title', '');
    $(_selector).empty();
    _html = generateOption('NAN', 'انتخاب کنید') + _html;
    $(_selector).append(_html);
};

var initOtaghBarByVehicleId = function(vhid) {
    var _selector = '.otaghBar_select';
    var _otaghBar = getOtaghBarByVehicleId(vhid);
    var _html = generateMultipleOptions(_otaghBar, 'object_id', 'title', '');
    $(_selector).empty();
    _html = generateOption('NAN', 'انتخاب کنید') + _html;
    $(_selector).append(_html);
};

var initPelakByVehicleId = function(vhid) {
    var _selector = '.pelak_select';
    var _pelak = getPelakByVehicleId(vhid);
    var _html = generateMultipleOptions(_pelak, 'object_id', 'title', '');
    $(_selector).empty();
    _html = generateOption('NAN', 'انتخاب کنید') + _html;
    $(_selector).append(_html);
};

var getCityByProvinceId = function(ctid) {
    var province_data = window[ctfield];
    var _city = [];
    $(province_data).each(function(index, cd){
        if(cd.id == parseInt(ctid)){
            _city = cd.cities;
        }
    });
    return _city;
};
var getTipByVehicleId = function(tpid) {
    var vehicle_data = window[tipfield];
    var _tip = [];
    $(vehicle_data).each(function(index, tp){
        if(tp.id == parseInt(tpid)){
            _tip = tp.tips;
        }
    });
    return _tip;
};

var getUsageByVehicleId = function(id) {
    var vehicle_data = window[tipfield];
    var _usage = [];
    $(vehicle_data).each(function(index, usg){
        if(usg.id == parseInt(id)){
            _usage = usg.usages;
        }
    });
    return _usage;
};

var getOtaghBarByVehicleId = function(id) {
    var vehicle_data = window[tipfield];
    var _otaghBar = [];
    $(vehicle_data).each(function(index, otg){
        if(otg.id == parseInt(id)){
            _otaghBar = otg.otagh_bars;
        }
    });
    return _otaghBar;
};

var getPelakByVehicleId = function(id) {
    var vehicle_data = window[tipfield];
    var _pelak = [];
    $(vehicle_data).each(function(index, plk){
        if(plk.id == parseInt(id)){
            _pelak = plk.pelaks;
        }
    });
    return _pelak;
};

var initAll = function() {
    initNumberInputs();
    initInteractiveInputs();
    if (typeof (vehicle_type_data_url) !== 'undefined') {
        initVehicleTypeData();
    }
    if(typeof (car_data_url) !== 'undefined') {
        initCarData();
    }
    if(typeof (city_data_url) !== 'undefined') {
        initCityData();
    }
    initBuildYears();
    initBirthYears();
    initStartYears();
    initBirthMonth();
    initBirthDays();
    initFireBuildYears();
    initSelects();
    initThirdParty();
    initBodyInsurance();
    /*if(typeof (motorcycle_data_url) !== 'undefined') {
        initMotorcycleInsurance();
    }*/
    initLifeInsurance();
    
    if(typeof (tip_data_url) !== 'undefined') {
        initTipData();
    }
    generateFundChangeEvent();
    $(document).ready(function(){
        init2OptionCheckBoxes();
        ili('select[id*=previous_company_select]').trigger('change');
    });
};

initAll();











